import { TitleCasePipe } from '@angular/common';
import { Component, effect, input, output } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { CheckboxModule } from 'src/app/project/components/input/checkbox/checkbox.module';
import { TReminderFilterOption, TReminderFilterOptions } from '../../reminder-filters.consts';

@Component({
  selector: 'pp-reminder-options-list',
  imports: [CheckboxModule, PipesModule, TitleCasePipe],
  templateUrl: './reminder-options-list.component.html',
  styleUrl: './reminder-options-list.component.scss',
})
export class ReminderOptionsListComponent {
  ppOptions = input<TReminderFilterOptions>();
  ppOptionsChange = output<TReminderFilterOptions>();

  allSelected = false;

  constructor() {
    effect(() => {
      this.updateAllSelectedStatus();
    });
  }

  ngOnChanges(): void {
    this.updateAllSelectedStatus();
  }

  private updateAllSelectedStatus(): void {
    this.allSelected = this.ppOptions().options.every((option) => option.selected);
  }

  changeOption(option: TReminderFilterOption): void {
    option.selected = !option.selected;
    this.ppOptionsChange.emit({ ...this.ppOptions(), options: [...this.ppOptions().options] });
  }

  toggleAll(): void {
    this.ppOptions().options.forEach((option) => {
      option.selected = !this.allSelected;
    });

    this.ppOptionsChange.emit({ ...this.ppOptions(), options: [...this.ppOptions().options] });
  }
}
